<template>
    <div>
        <load-screen-component :is-loading="isLoading"></load-screen-component>
        <page-header pageTitle="PANEL.INDEX_TITLE" :btnNew="'Visualizar Planos'" :iconBtnNew="'icon-eye1 font-15'"
                     have-search @searching="setFilter"
                     @newType="this.$router.push('/planos')"/>
        <div v-if="items?.data" class="card">
            <div v-for="(iten, key) in items.data" :key="iten.id" :class="key !=0 ? 'border-top2': ''">
                <div class="row space-between mt-2" style="margin-left: -22px;">
                    <div @click="open(iten)" class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                        <div class="list-primary hide-text"> {{ iten.company_name }}</div>
                    </div>
                    <div @click="open(iten)" class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5 ml-negative-1">
                        <div class="color-grey">
                            <a class="button-center">
                                <i class="icon-keyboard_arrow_down pointer" v-if="!iten.open"></i>
                                <i class="icon-keyboard_arrow_up pointer" v-if="iten.open"></i>
                            </a>
                        </div>
                    </div>
                    <div class="col-1 mr-1 w-auto">
                        <div class="text-right">
                            <a type="button" data-toggle="dropdown" aria-haspopup="true"
                               aria-expanded="false"
                               style="font-size: 20px" id="listDropdown">
                                <i class="icon-more_vert" title="Opções"></i>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right dropdown-black" style="width: max-content">
                                <div class="dropdown-item pointer text-white"
                                     @click="setModalAllotments(iten.company_id)">
                                    <i class="icon-eye1 font-15"/>{{ t('PANEL.INFORM_DB_CONNECTION') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <transition name="fade">
                    <div v-if="iten.open">
                        <div class="table-settings border-top2 detail-shadow-t">
                            <div class="pl-3 mt-2">
                                <div class="d-flex flex-column align-items-center w-100">
                                    <SectionCardComponent
                                            eyebrow="Plano"
                                            :title="t('PANEL.CONFIG_PLAN')"
                                            subtitle="Configure o plano contratado, o token do WhatsApp, os dias de arrependimento e a exibição de dados na ficha do cliente."
                                            icon="icon-domain"
                                            customClass="w-100">
                                        <div class="row gutters w-100 mb-3">
                                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12">
                                                <div class="form-group" style="width: 100%">
                                                    <label :for="'plan' + key">{{ t('PANEL.PLAN.PLANS') }} </label>
                                                    <select2 :id="'plan' + key" :options="plans" v-model="iten.plan.select"
                                                             :settings="{'width' : '100%'}"
                                                             @select="alterPlan(iten.plan.select, key)"
                                                             :placeholder="iten.plan.name"></select2>
                                                </div>
                                            </div>
                                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                                <div class="form-group" style="width: 100%">
                                                    <label for="token_w">{{ t('PANEL.WHATSAPP_TOKEN') }} </label>
                                                    <input type="text" id="token_w" class="form-control"
                                                           placeholder="WhatsApp Token" maxlength="100"
                                                           v-model="iten.whatsapp_token">
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12">
                                                <div class="form-group" style="width: 100%">
                                                    <label for="DAY_REPETANCE">{{ t('PANEL.DAY_REPETANCE') }}<i
                                                            class="icon-info"
                                                            title="Dias para descartar reserva confirmada caso venda seja cancelada">
                                                    </i></label>
                                                    <input type="number" class="form-control"
                                                           id="DAY_REPETANCE"
                                                           placeholder="7"
                                                           v-model="iten.days_repentance"
                                                    >
                                                </div>
                                            </div>
                                            <div class="col-xl-4 col-lg-4 col-12 d-flex">
                                                <div class="custom-control custom-switch align-self-center">
                                                    <input type="checkbox" class="custom-control-input" :id="`can_show_info_company_on_fich_client${iten.id}`"
                                                           v-model="iten.can_show_info_company_on_fich_client">
                                                    <label class="custom-control-label"
                                                           :for="`can_show_info_company_on_fich_client${iten.id}`">{{ t('PANEL.CAN_SHOW_INFO_COMPANY_ON_FICH_CLIENT') }}</label>
                                                </div>
                                            </div>
                                            <div class="plan-specs__header">
                                                <span class="plan-specs__header-icon"><i class="icon-subject"></i></span>
                                                <span class="plan-specs__header-title">{{ t('PANEL.EXPEC_PLAN') }}:</span>
                                                <span class="plan-specs__header-plan">{{ iten.plan.name }}</span>
                                            </div>
                                            <div class="plan-specs">
                                                <div class="plan-specs__item">
                                                    <span class="plan-specs__label">{{ t('PANEL.PLAN.MAX_LOTS_PERMITED') }}</span>
                                                    <strong class="plan-specs__value">{{ iten.plan.max_lots_permitted }}</strong>
                                                </div>
                                                <div class="plan-specs__item">
                                                    <span class="plan-specs__label">{{ t('PANEL.PLAN.EMAIL_NOTIFICATIOS') }}</span>
                                                    <strong class="plan-specs__value">{{ iten.plan.email_notifications }}</strong>
                                                </div>
                                                <div class="plan-specs__item">
                                                    <span class="plan-specs__label">{{ t('PANEL.PLAN.WHATSAPP_NOTIFICATIONS') }}</span>
                                                    <strong class="plan-specs__value">{{ iten.plan.whatsapp_notifications }}</strong>
                                                </div>
                                                <div class="plan-specs__item">
                                                    <span class="plan-specs__label">{{ t('PANEL.PLAN.MAX_SIZE_DRIVE') }}</span>
                                                    <strong class="plan-specs__value">{{ formatPlanStorage(iten.plan.size_store_drive) }}</strong>
                                                </div>
                                            </div>

                                        </div>
                                    </SectionCardComponent>
                                    <SectionCardComponent
                                            :eyebrow="t('PANEL.CONFIG_NOTIFICATION_ZAP')"
                                            :title="t('PANEL.CONFIG_NOTIFICATION_ZAP')"
                                            subtitle="Defina quais eventos devem gerar notificações automáticas enviadas via WhatsApp."
                                            icon="icon-notifications"
                                            customClass="w-100">
                                    <div class="notify-grid">
                                            <div class="notify-item">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" :id="`reserve_create${iten.id}`"
                                                           v-model="iten.notify_reserve_create">
                                                    <label class="custom-control-label"
                                                           :for="`reserve_create${iten.id}`">{{ t('PANEL.NOTIFY_RESERVE_CREATE') }}</label>
                                                </div>
                                            </div>
                                            <div class="notify-item">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" :id="`reserve_confirmed${iten.id}`"
                                                           v-model="iten.notify_reserve_confirmed">
                                                    <label class="custom-control-label"
                                                           :for="`reserve_confirmed${iten.id}`">{{ t('PANEL.NOTIFY_RESERVE_CONFIRMED') }}</label>
                                                </div>
                                            </div>
                                            <div class="notify-item">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" :id="`reserve_derrubed${iten.id}`"
                                                           v-model="iten.notify_reserve_derrubed">
                                                    <label class="custom-control-label"
                                                           :for="`reserve_derrubed${iten.id}`">{{ t('PANEL.NOTIFY_RESERVE_DERRUBED') }}</label>
                                                </div>
                                            </div>
                                            <div class="notify-item">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" :id="`reserve_renew${iten.id}`"
                                                           v-model="iten.notify_reserve_renew">
                                                    <label class="custom-control-label"
                                                           :for="`reserve_renew${iten.id}`">{{ t('PANEL.NOTIFY_RESERVE_RENEW') }}</label>
                                                </div>
                                            </div>
                                            <div class="notify-item">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" :id="`reserve_indertemined${iten.id}`"
                                                           v-model="iten.notify_reserve_indertemined">
                                                    <label class="custom-control-label"
                                                           :for="`reserve_indertemined${iten.id}`">{{ t('PANEL.NOTIFY_RESERVE_INDERTEMINED') }}</label>
                                                </div>
                                            </div>
                                            <div class="notify-item">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" :id="`reserve_expired${iten.id}`"
                                                           v-model="iten.notify_reserve_expired">
                                                    <label class="custom-control-label"
                                                           :for="`reserve_expired${iten.id}`">{{ t('PANEL.NOTIFY_RESERVE_EXPIRED') }}</label>
                                                </div>
                                            </div>
                                            <div class="notify-item">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" :id="`proposal_create${iten.id}`"
                                                           v-model="iten.notify_proposal_create">
                                                    <label class="custom-control-label"
                                                           :for="`proposal_create${iten.id}`">{{ t('PANEL.NOTIFY_PROPOSAL_CREATE') }}</label>
                                                </div>
                                            </div>
                                            <div class="notify-item">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" :id="`create_client_public${iten.id}`"
                                                           v-model="iten.notify_create_client_public">
                                                    <label class="custom-control-label"
                                                           :for="`create_client_public${iten.id}`">{{ t('PANEL.NOTIFY_CREATE_CLIENT_PUBLIC') }}</label>
                                                </div>
                                            </div>
                                            <div class="notify-item">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" :id="`notify_reserve_client_belongs_anoter_broker${iten.id}`"
                                                           v-model="iten.notify_reserve_client_belongs_anoter_broker">
                                                    <label class="custom-control-label"
                                                           :for="`notify_reserve_client_belongs_anoter_broker${iten.id}`">{{ t('PANEL.NOTIFY_CREATE_RESERVE_CLIENT_BELONGS_ANOTER_BROKER') }}</label>
                                                </div>
                                            </div>
                                    </div>
                                    </SectionCardComponent>
                                    <div class="panel-actions">
                                        <button data-toggle="modal" data-target="#customModalTwo"
                                                @click="updateCompany(iten, key)"
                                                class="panel-save-btn">
                                            <span class="panel-save-btn__icon"><i class="icon-save"></i></span>
                                            <span class="panel-save-btn__label">{{ t('ACTIONS.SAVE') }} configuração</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <div class="card" v-if="items && items.validations || !items?.data">
            <div class="card-header"></div>
            <div class="card-body pt-0">
                <div class="text-center">
                    <h5>{{ t('GENERAL.MSG.NONE_PANEL_FOUND') }}</h5>
                </div>
            </div>
        </div>
        <modal-add-id-configd
                v-if="modalChosen == 1"
                @close="closeModalAdd"
                :allotments-index="allotments"
        ></modal-add-id-configd>
        <pagination-component v-if="items && items.data && items.data[0]" :items="items"
                              :to="'/painel-administrativo'"
                              @changePage="index(filter, $event)"></pagination-component>
    </div>
</template>

<script>
import {useToast} from "vue-toastification";
import {useI18n} from "vue-i18n";
import PageHeader from "@/components/layouts/pageHeader";
import LoadScreenComponent from "@/components/layouts/loadScreenComponent";
import Panel from "@/services/Panel";
import Plan from "@/services/Plan";
import Select2 from "vue3-select2-component";
import PaginationComponent from "@/components/layouts/PaginationComponent";
import 'vue-select/dist/vue-select.css';
import Validate from "@/components/validate";
import Allotments from '../../services/Allotments';
import modalAddIdConfigd from './modalAddIdConfigd';
import {Money3Directive} from 'v-money3';
import jwt_decode from 'jwt-decode';
import {mapState} from 'vuex';
import SectionCardComponent from '../../components/layouts/SectionCardComponent';

export default {
    name: "indexComponent",
    mixins: [Validate],
    directives: {money3: Money3Directive},
    components: {
        PageHeader,
        LoadScreenComponent,
        PaginationComponent,
        Select2,
        modalAddIdConfigd,
        SectionCardComponent,
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    computed: {
        ...mapState({
            isLoading: 'isLoading'
        })
    },
    data() {
        return {
            items: null,
            plans: [],
            allotments: [],
            modalChosen: null,
            filter: null,
            invalidQtdMaxB: null,
            invalidQtdMov: null,
            amountMaxBillConfig: {
                min: 0.00,
                prefix: 'R$ ',
                masked: true,
                decimal: ',',
                precision: 2,
                disabled: false,
                thousands: '.',
                allowBlank: false,
                disableNegative: true,
            },
            amountMinBillConfig: {
                min: 0.00,
                prefix: 'R$ ',
                masked: true,
                decimal: ',',
                precision: 2,
                disabled: false,
                thousands: '.',
                allowBlank: false,
                disableNegative: true,
            },
            sizeDriveConfig: {
                min: 0.00,
                suffix: ' GB',
                masked: true,
                decimal: '.',
                precision: 2,
                disabled: false,
                thousands: '',
                allowBlank: false,
                disableNegative: true,
            },
        }
    },
    mounted() {
        if (!this.hasPermissionShowPanel()) {
            this.$router.push({name: 'Home'});
        }
        this.index();
        this.planIndex();
    },
    methods: {
        hasPermissionShowPanel() {
            let token = jwt_decode(localStorage.getItem('access_token'));
            return token.login.includes('@r2soft.com.br');
        },
        setFilter(term) {
            this.filter = term;
            this.index(this.filter);
        },
        closeModalAdd() {
            this.modalChosen = null;
        },
        index(filter = null, page = 1) {
            this.$store.commit('changeLoading', true);
            Panel.index(filter, page, true).then((res) => {
                this.items = res.data;
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.items = {};
                this.$store.commit('changeLoading', false);
            });
        },
        setModalAllotments(companyId) {
            this.$store.commit('changeLoading', true);
            Allotments.listByCompany(companyId).then(resp => {
                this.allotments = resp.data;
                this.modalChosen = 1;
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.$store.commit('changeLoading', false);
            })
        },
        open(iten) {
            iten.open = !iten.open ? true : false;
        },
        updateCompany(data) {
            if (data?.days_repentance === null || data?.days_repentance === undefined) {
                data.days_repentance = 7;
            }
            this.$store.commit('changeLoading', true);
            this.items = null;
            Panel.update(data).then(async () => {
                this.$store.commit('changeLoading', true);
                this.index(this.filter);
            }).catch(async (err) => {
                await this.index(this.filter);
                this.errorMsg(err);
                this.$store.commit('changeLoading', false);
            })
        },
        planIndex() {
            Plan.listAll().then((res) => {
                this.plans = res.data;
            })
        },
        alterPlan(id, key) {
            this.$store.commit('changeLoading', true);
            Plan.show(id).then((res) => {
                this.items.data[key].plan = res.data;
                this.items.data[key].plan.select = id;
            }).finally(() => this.$store.commit('changeLoading', false));
        },
        formatPlanStorage(value) {
            if (value === null || value === undefined || value === '') {
                return '0.00 GB';
            }
            const numeric = String(value).replace(/[^\d.,-]/g, '').replace(',', '.');
            const parsed = parseFloat(numeric);
            if (isNaN(parsed)) {
                return String(value) + ' GB';
            }
            return parsed.toFixed(2) + ' GB';
        },
    }
}
</script>

<style scoped>
.button-center {
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: left;
    color: #333333;
    border-radius: 50px;
    font-size: 160%;
}

.table-settings {
    padding-top: 0.6rem !important;
    padding-right: 1rem !important;
    padding-bottom: 0.1rem !important;
    background-color: white !important;
}

.fade-enter-active, .fade-leave-active {
    -webkit-transition: .1s ease-out;
    -moz-transition: .1s ease-out;
    transition: .1s ease-out;
}

.fade-enter, .fade-leave-to {
    -webkit-transition: .1s ease-out;
    -moz-transition: .1s ease-out;
    transition: .1s ease-out;
}

.space-between {
    padding-bottom: 8px;
    align-items: center;
    justify-content: space-between;
}

.font-seven {
    font-size: 0.7rem !important;
}

.detail {
    display: flex;
    padding-left: 2%;
    padding-right: 2%;
    align-items: center;
    justify-content: space-between;
}

.dropdown-menu-custom {
    right: 0px !important;
    left: 13px !important;
    width: 7rem !important;
    min-width: 7rem !important;
}

.ml-negative-1 {
    margin-left: -3.5%;
    padding-left: 0px
}

.panel-actions {
    border-top: 1px solid #eef2f0;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.panel-save-btn {
    align-items: center;
    background: linear-gradient(135deg, #0e5e4e 0%, #0b7a5f 100%);
    border: 0;
    border-radius: 50px;
    box-shadow: 0 6px 18px rgba(14, 94, 78, 0.28);
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    font-size: 14px;
    font-weight: 700;
    gap: 10px;
    padding: 5px 24px 5px 20px;
    transition: box-shadow .15s ease, transform .15s ease;
}

.panel-save-btn:hover {
    box-shadow: 0 8px 24px rgba(14, 94, 78, 0.38);
    transform: translateY(-1px);
}

.panel-save-btn:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(14, 94, 78, 0.25);
}

.panel-save-btn__icon {
    align-items: center;
    background: rgba(255, 255, 255, 0.18);
    border-radius: 50%;
    display: inline-flex;
    flex: 0 0 30px;
    height: 30px;
    justify-content: center;
    width: 30px;
}

.panel-save-btn__icon i {
    font-size: 15px;
}

.plan-specs__header {
    align-items: center;
    display: flex;
    gap: 8px;
    margin: 16px 0 10px;
}

.plan-specs__header-icon {
    align-items: center;
    background: #e7f4f0;
    border-radius: 8px;
    color: #0e5e4e;
    display: inline-flex;
    flex: 0 0 30px;
    height: 30px;
    justify-content: center;
    width: 30px;
}

.plan-specs__header-title {
    color: #3a4f49;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: .02em;
    text-transform: uppercase;
}

.plan-specs__header-plan {
    color: #0e5e4e;
    font-size: 13px;
    font-weight: 700;
    margin-left: -4px;
    text-transform: capitalize;
}

.plan-specs {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(4, 1fr);
    margin: 0 0 14px;
    width: 100%;
}

.plan-specs__item {
    background: #f6f8f8;
    border-radius: 10px;
    border: 1px solid #e8ecec;
    padding: 10px 14px;
}

.plan-specs__label {
    color: #87958f;
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .03em;
    margin-bottom: 4px;
    text-transform: uppercase;
}

.plan-specs__value {
    color: #3a4f49;
    display: block;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.25;
}

.notify-grid {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(3, 1fr);
    margin: 0 0 14px;
    width: 100%;
}

.notify-item {
    align-items: center;
    background: #f6f8f8;
    border: 1px solid #e8ecec;
    border-radius: 10px;
    display: flex;
    padding: 12px 14px;
}

@media (max-width: 991px) {
    .notify-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 575px) {
    .notify-grid {
        grid-template-columns: 1fr;
    }
}

:global(html.dark-theme .notify-item) {
    background: rgba(148, 163, 184, 0.08) !important;
    border-color: rgba(148, 163, 184, 0.16) !important;
}

@media (max-width: 991px) {
    .plan-specs {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 575px) {
    .plan-specs {
        grid-template-columns: 1fr;
    }
}

:global(html.dark-theme .plan-specs__header-icon) {
    background: var(--dark-primary-soft) !important;
    color: #5eead4 !important;
}

:global(html.dark-theme .plan-specs__header-title) {
    color: var(--dark-text) !important;
}

:global(html.dark-theme .plan-specs__header-plan) {
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .plan-specs__item) {
    background: rgba(148, 163, 184, 0.08) !important;
    border-color: rgba(148, 163, 184, 0.16) !important;
}

:global(html.dark-theme .plan-specs__label) {
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .plan-specs__value) {
    color: var(--dark-text) !important;
}
</style>